// John Eldhose 20180522
import React, { Component } from 'react';
import  { Link, Redirect } from 'react-router-dom';
import { Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import { isAuthenticated } from '../Api/isAuthenticated';
import { FormattedMessage } from 'react-intl';
import Profile from './home/Profile';
import ManageAccount from './home/ManageAccount';
import PhotoCapture from './home/PhotoCapture';
import Academy from './home/Academy';
import AccountDetailsTeam from './home/AccountDetailsTeam';
import Contact from './home/Contact';
import Demo from './home/Demo';
import Downloads from './home/Downloads';
import LMDRMAs from './home/LMDRMAs';
import LMDRMAForm from './home/LMDRMAForm';
import ProductsPlans from './home/ProductsPlans';
import Communications from './home/Communications';
import ShoppingCart from './home/ShoppingCart';
import Reconfig from './home/Reconfig';
import Renew from './home/Renew';
import RMAs from './home/RMAs';
import RMAForm from './home/RMAForm';
import Purchase from './home/Purchase';
import Forum from './home/Forum';

class HomeLayout extends Component {

  state = {
    loaded: false,
    isAuth: 0,
    academyDemo: 0
  }
  checkAuth = () => {
    isAuthenticated()
      .then((auth) => {
        if(auth.status === 'true')
          this.setState({ isAuth: auth.auth, academyDemo: auth.academyDemo, loaded: true });
        else
          this.setState({ loaded: true });
      })
      .catch(() => {
        this.setState({loaded: true});
      })
  }
  componentWillMount() {
    this.checkAuth();
  }

  getHomeContent = () => {
    if(this.state.isAuth === 7)
      return <Profile />;
    if(this.state.isAuth > 0 && (this.state.isAuth % 5) === 0)
      switch (this.props.match.path) {
        case '/accountdetailsteam':
          return <AccountDetailsTeam />;
        case '/communications':
          return <Communications />;
        case '/lmdrmas':
          return <LMDRMAs />;
        case '/lmdrmaform':
          return <LMDRMAForm />;
        case '/manageaccount':
          return <ManageAccount />;
        case '/productsplans':
          return <ProductsPlans />;
        case '/rmas':
          return <RMAs />;
        case '/rmaform':
          return <RMAForm />;
        case '/shoppingcart':
          return <ShoppingCart />;
        default:
      }
    switch (this.props.match.path) {
      case '/contact':
        return <Contact />;
      case '/demo':
        return <Demo />;
      case '/downloads':
        return <Downloads />;
      case '/forum':
        return <Forum />;
      case '/photocapture':
        return <PhotoCapture prompt={(this.state.isAuth % 5) !== 0} />;
      case '/profile':
        return <Profile />;
      case '/purchase':
        return <Purchase />;
      case '/reconfig':
        return <Reconfig />;
      case '/renew':
        return <Renew />;
      default:
        return (<Redirect to='/'  />);
    }
  }
  setBackButton = () => {
    if(this.props.location.search === '?rmaform')
      return (
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/rmaform' fullWidth>
              <FormattedMessage
                id='Return to RMA Form'
                defaultMessage='Return to RMA Form'
              />
            </Button>
          </Grid>
        </Grid>
      );
    else if(this.props.location.search === '?lmdrmaform')
      return (
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/lmdrmaform' fullWidth>
              <FormattedMessage
                id='Return to LMD RMA Form'
                defaultMessage='Return to LMD RMA Form'
              />
            </Button>
          </Grid>
        </Grid>
      );
    switch (this.props.match.path) {
      case '/accountdetailsteam':
        return (
          <Grid container>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/manageaccount' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/productsplans' fullWidth>
                <FormattedMessage
                  id='Products & Plans'
                  defaultMessage='Products & Plans'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/communications' fullWidth>
                <FormattedMessage
                  id='Communications'
                  defaultMessage='Communications'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/communications':
        return (
          <Grid container>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/manageaccount' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/accountdetailsteam' fullWidth>
                <FormattedMessage
                  id='Account Details & Users'
                  defaultMessage='Account Details & Users'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/productsplans' fullWidth>
                <FormattedMessage
                  id='Products & Plans'
                  defaultMessage='Products & Plans'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/lmdrmas':
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/manageaccount' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/lmdrmaform':
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/lmdrmas' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/productsplans':
        return (
          <Grid container>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/manageaccount' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/accountdetailsteam' fullWidth>
                <FormattedMessage
                  id='Account Details & Users'
                  defaultMessage='Account Details & Users'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Button component={Link} to='/communications' fullWidth>
                <FormattedMessage
                  id='Communications'
                  defaultMessage='Communications'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/rmas':
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/manageaccount' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/rmaform':
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/rmas' fullWidth>
                <FormattedMessage
                  id='Go Back'
                  defaultMessage='Go Back'
                />
              </Button>
            </Grid>
          </Grid>
        );
      case '/shoppingcart':
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/productsplans' fullWidth>
                <FormattedMessage
                  id='Continue Shopping'
                  defaultMessage='Continue Shopping'
                />
              </Button>
            </Grid>
          </Grid>
        );
      default:
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button component={Link} to='/' fullWidth>
                <FormattedMessage
                  id='Return to Account Home'
                  defaultMessage='Return to Account Home'
                />
              </Button>
            </Grid>
          </Grid>
        );
    }
  }

  render() {
    if(!this.state.loaded) {
      return(
        <div style={{ height: '100%' }}>
          <div style={{ height: '170px' }}>&nbsp;</div>
          <CircularProgress size={50} style={{ color: '#00A8E4' }} />
        </div>
      );
    }
    else if(this.state.isAuth > 0) {
      switch (this.props.match.path) {
        case '/academy':
          return (
            <Academy
              isAuth={this.state.isAuth}
              academyDemo={this.state.academyDemo}
            />);
        default:
          return (
            <div>
              {this.setBackButton()}
              <p />
              <Divider />
              <p />
              <Grid container>
                <Grid item xs={12} sm={12} md={12} className='ProductItem'>
                  {this.getHomeContent()}
                </Grid>
              </Grid>
              <p />
              <Divider />
              <p />
              {this.setBackButton()}
            </div>
          );
      }
    }
    else {
      const search = window.location.search;
      switch (this.props.match.path) {
        case '/contact':
          return <Redirect to={'/contactsales' + search} />;
        case '/demo':
          return <Redirect to={'/demoproducts' + search} />;
        case '/forum':
          return <Redirect to={'/forumauth' + search} />;
        case '/purchase':
          return <Redirect to={'/purchaseproducts' + search} />;
        case '/reconfig':
          return <Redirect to={'/reconfigproduct' + search} />;
        case '/renew':
          return <Redirect to='/renewproduct' />;
        default:
          return <Redirect to='/login'  />;
      }
    }
  }
}

export default HomeLayout;



// WEBPACK FOOTER //
// ./src/components/HomeLayout.js